export default __webpack_public_path__ + "dist/media/UnarchiveNda.9743f9f2.svg";